export const classes = {
  imgWrapper:
    'size-12 place-center bg-white dark:bg-white/[0.07] rounded-xl shadow-card',
  imgWrapperDense: 'size-8 rounded-lg',
  img: 'rounded-lg max-w-full max-h-full bg-white dark:bg-white/[0.07]',
};
